import { Box, Button, Text, Collapse, Group, Tabs } from '@mantine/core';
import { useState } from 'react'
import { ChartBar, ChevronDown, ChevronUp, ChartPie } from 'tabler-icons-react';
import { useGetProspectsStatsQuery } from '../../redux/features/parentApi';
import TabViews from '../../components/TabViews';
import { Outlet } from 'react-router-dom';
import LoginStatsChart from '../../components/LoginStatsChart';
import UTMStatsChart from '../../components/UTMStatsChart';

const CATEGORY_CONFIG = [
    { key: 'CONTACT',        label: 'Contacts',          path: '' },
    { key: 'PROSPECT',       label: 'Prospects',         path: 'prospects' },
    { key: 'USER',           label: 'Utilisateurs',      path: 'users' },
    { key: 'USER_ACTIVE',    label: 'Utilisateurs activés', path: 'users-actives' },
    { key: 'CLIENT',         label: 'Clients',           path: 'clients' },
    { key: 'CLIENT_ACTIF',   label: 'Clients actifs',    path: 'clients-actifs' },
    { key: 'CLIENT_ENGAGE',  label: 'Clients engagés',   path: 'clients-engages' },
    { key: 'CLIENT_IMPACTE', label: 'Clients impactés',  path: 'clients-impactes' },
];

export default function ProspectPage() {
    const [showStats, setShowStats] = useState(false);
    const [statsTab, setStatsTab] = useState("connexion");

    const { data: statsData, isLoading: statsLoading } = useGetProspectsStatsQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });

    const display = (count, loading) => loading ? '...' : count;

    const tabs = [
        ...CATEGORY_CONFIG.map(({ key, label, path }) => ({
            label: `${label} (${display(statsData?.data?.[key] ?? 0, statsLoading)})`,
            path,
        })),
        { label: "Messages", path: "messages" },
    ];

    return (
        <div>
            <Box>
                <Group position="apart" mb="md">
                    <Text size="xl">
                        Gestion des prospects
                    </Text>
                    <Button
                        variant="light"
                        leftIcon={<ChartBar size={18} />}
                        rightIcon={showStats ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                        onClick={() => setShowStats(!showStats)}
                    >
                        {showStats ? "Masquer les statistiques" : "Voir les statistiques de connexion"}
                    </Button>
                </Group>
            </Box>

            <Collapse in={showStats}>
                <Box mb="lg">
                    <Tabs value={statsTab} onTabChange={setStatsTab}>
                        <Tabs.List>
                            <Tabs.Tab value="connexion" icon={<ChartBar size={16} />}>
                                Statistiques de connexion
                            </Tabs.Tab>
                            <Tabs.Tab value="utm" icon={<ChartPie size={16} />}>
                                Statistiques de provenance (UTM)
                            </Tabs.Tab>
                        </Tabs.List>

                        <Tabs.Panel value="connexion" pt="md">
                            <LoginStatsChart title="Activité de connexion des parents et prospects" />
                        </Tabs.Panel>

                        <Tabs.Panel value="utm" pt="md">
                            <UTMStatsChart
                                title="Analyse des sources d'acquisition (UTM)"
                            />
                        </Tabs.Panel>
                    </Tabs>
                </Box>
            </Collapse>

            <TabViews tabs={tabs} />
            <Box>
                <Outlet />
            </Box>
        </div>
    )
}
